export const USER_PROFILE_SECTIONS = [
  'orders',
  'address',
  'wishlist',
  'notifications',
  'coupons',
  'scrap-certificate',
  'my-garage',
  'profile-faq',
  'customer-support',
] as const;

export type UserProfileSection = (typeof USER_PROFILE_SECTIONS)[number];

export function isUserProfileSection(
  value: string | null | undefined,
): value is UserProfileSection {
  return (
    !!value &&
    USER_PROFILE_SECTIONS.includes(value as UserProfileSection)
  );
}

export function userProfileSectionQuery(section: UserProfileSection): {
  section: UserProfileSection;
} {
  return { section };
}
